import { jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { useIsClient } from "../../hooks/use-is-client.js";
import { getIconByName } from "./IconsDefault.js";
const Icon = ({
  variant,
  CustomIcon,
  width = 24,
  height = 24,
  fallBackProps,
  ...svgProps
}) => {
  const isClient = useIsClient();
  const FallbackComponent = ({ style, ...props }) => /* @__PURE__ */ jsx("span", { style, ...props });
  const fallback = /* @__PURE__ */ jsx(FallbackComponent, { style: { width, height }, ...fallBackProps });
  if (!isClient) {
    return fallback;
  }
  if (CustomIcon) {
    return /* @__PURE__ */ jsx(Suspense, { fallback, children: /* @__PURE__ */ jsx(CustomIcon, { width, height, ...svgProps }) });
  }
  if (variant) {
    const VariantIcon = getIconByName(variant);
    return /* @__PURE__ */ jsx(Suspense, { fallback, children: /* @__PURE__ */ jsx(VariantIcon, { width, height, ...svgProps }) });
  }
  return fallback;
};
export {
  Icon
};
